// react
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAsp';

// types
import { OrderType } from 'types/order';

const RentracksTag = () => {
  const { isThanks, order } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'rentracks';
    const loadScriptId = 'rentracks-load';
    const isExistScript = document.getElementById(scriptId);
    const isExistLoadScript = document.getElementById(loadScriptId);
    if (!!isExistScript) isExistScript.remove();
    if (!!isExistLoadScript) isExistLoadScript.remove();

    const orderCode = order ? (order as OrderType).order_code : '';
    const script = document.createElement('script');
    script.id = scriptId;
    script.innerHTML = isThanks
      ? `
  (function(){
    function loadScriptRTCV(callback){
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = "${loadScriptId}";
    script.src = 'https://www.rentracks.jp/js/itp/rt.track.js?t=' + (new Date()).getTime();
    if ( script.readyState ) {
    script.onreadystatechange = function() {
    if ( script.readyState === 'loaded' || script.readyState === 'complete' ) {
    script.onreadystatechange = null;
    callback();
    };
    };
    } else {
    script.onload = function() {
    callback();
    };
    };
    document.getElementsByTagName('head')[0].appendChild(script);
    }
    
    loadScriptRTCV(function(){
    _rt.sid = 3848;
    _rt.pid = 14653;
    _rt.price = 0;
    _rt.reward = -1;
    _rt.cname = '';
    _rt.ctel = '';
    _rt.cemail = '';
    _rt.cinfo = '${orderCode}';
    rt_tracktag();
    });
    }(function(){}));
      `
      : `
    (function(callback){
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://www.rentracks.jp/js/itp/rt.track.js?t=" + (new Date()).getTime();
      if ( script.readyState ) {
      script.onreadystatechange = function() {
      if ( script.readyState === "loaded" || script.readyState === "complete" ) {
      script.onreadystatechange = null;
      callback();
      }
      };
      } else {
      script.onload = function() {
      callback();
      };
      }
      document.getElementsByTagName("head")[0].appendChild(script);
      }(function(){}));
      `;
    document.body.appendChild(script);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return <></>;
};

export default RentracksTag;
